import { getWeekArray } from "../../helper";

type data = {
  title: string;
  description: string;
  location: string;
  whatsapp: string;
  phone: string;
  imageUrl: string;
  date: string;
  endDate: string;
  deepLinkId: string;
  deepLinkType: string;
  isInactive: string;
};

export const validateCreateEvent = (
  data: data,
  time: any,
  setError: (a: any) => void,
) => {
  let isError = false;
  let numSpacesRegex = /^\+\d+/;
  let isContactValid = data.phone ? numSpacesRegex.test(data.phone) : true;
  let isWhatsappValid = data.whatsapp
    ? numSpacesRegex.test(data.whatsapp)
    : true;

  if (data.title === "") {
    setError((prevState: any) => ({
      ...prevState,
      title: "Please enter Event title",
    }));
    isError = true;
  }
  if (data.description === "") {
    setError((prevState: any) => ({
      ...prevState,
      description: "Please enter Event description",
    }));
    isError = true;
  }
  if (data.location === "") {
    setError((prevState: any) => ({
      ...prevState,
      location: "Please enter Event location",
    }));
    isError = true;
  }
  if (!isWhatsappValid) {
    setError((prevState: any) => ({
      ...prevState,
      whatsapp: "Please enter a valid whatsapp number",
    }));
    isError = true;
  }
  if (!isContactValid) {
    setError((prevState: any) => ({
      ...prevState,
      phone: "Please enter a valid contact number",
    }));
    isError = true;
  }

  if (data.imageUrl === "") {
    setError((prevState: any) => ({
      ...prevState,
      imageUrl: "Please upload event image",
    }));
    isError = true;
  }

  if (data.isInactive === "") {
    setError((prevState: any) => ({
      ...prevState,
      isInactive: "Selecting status is mandatory",
    }));
    isError = true;
  }
  if (data.date === "") {
    setError((prevState: any) => ({
      ...prevState,
      date: "Please enter Event Start Date",
    }));
    isError = true;
  }

  if (data.deepLinkType === "parks") {
    if (!data.deepLinkId) {
      setError((prevState: any) => ({
        ...prevState,
        deepLinkId: "Please select one park",
      }));
      isError = true;
    }
  }

  if (new Date(data.endDate) < new Date(data.date)) {
    setError((prevState: any) => ({
      ...prevState,
      endDate: "Event End Date should be ahead of Event Start Date",
    }));
    isError = true;
  }

  if (time.type === "single") {
    if (time["timeSingle"].start === "" || time["timeSingle"].end === "") {
      setError((prevState: any) => ({
        ...prevState,
        timeSingle: "Start & End time is required",
      }));
      isError = true;
    }
    if (time["timeSingle"].start >= time["timeSingle"].end) {
      setError((prevState: any) => ({
        ...prevState,
        timeSingle: "End time should be before start",
      }));
      isError = true;
    }
    setError((prevState: any) => ({
      ...prevState,
      time: {
        mon: "",
        tue: "",
        wed: "",
        thu: "",
        fri: "",
        sat: "",
        sun: "",
      },
    }));
  } else if (time.type === "multi") {
    setError((prevState: any) => ({
      ...prevState,
      type: "",
    }));

    let timeError = {
      mon: "",
      tue: "",
      wed: "",
      thu: "",
      fri: "",
      sat: "",
      sun: "",
    };
    Object.keys(time.timeMulti).map((key) => {
      if (getWeekArray(data.date, data.endDate).indexOf(key) >= 0) {
        if (time.timeMulti[key].start && time.timeMulti[key].end === "") {
          // @ts-ignore
          timeError[key] = "End time is required";
        }
        if (time.timeMulti[key].end && time.timeMulti[key].start === "") {
          // @ts-ignore
          timeError[key] = "Start time is required";
        }
        // if (time.timeMulti[key].start !== "00:00" && (time.timeMulti[key].end === time.timeMulti[key].start)) {
        //   // @ts-ignore
        //   timeError[key] = "Start time is required";
        // }
        if (time.timeMulti[key].start > time.timeMulti[key].end) {
          // @ts-ignore
          timeError[key] = "End time should be before start";
        }
      }
    });

    let isEmpty = Object.values(timeError).every((x) => x === null || x === "");

    if (!isEmpty) {
      setError((prevState: any) => ({
        ...prevState,
        time: { ...timeError },
      }));
      isError = true;
    }
  } else {
    setError((prevState: any) => ({
      ...prevState,
      timeType: "Please select promotion time type",
    }));
    isError = true;
  }

  return isError;
};
